<template>
  <a
    class="pdv-apk-download"
    :href="href"
  >{{ label }}</a>
</template>
<script>
import { PDV_APK_LABEL, PDV_APK_PATH } from '@/constants/pdvApp'

export default {
  name: 'PdvApkDownload',
  computed: {
    href() {
      return PDV_APK_PATH
    },
    label() {
      return PDV_APK_LABEL
    },
  },
}
</script>
<style scoped>
.pdv-apk-download {
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
}
</style>
